import { useContext } from 'react'
import { BrandContext } from '../contexts/BrandContext'

/**
 * Hook para acessar informações da marca ativa
 *
 * @example
 * const { brand, config } = useBrand()
 *
 * // Acessar cores
 * const primaryColor = config.colors.primary
 *
 * // Verificar features
 * if (config.features.showHeader) {
 *   // Renderizar header
 * }
 *
 * // Acessar rotas
 * navigate(config.routes.home)
 */
export function useBrand() {
  const context = useContext(BrandContext)

  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider')
  }

  return context
}
